import React from 'react';
import * as Progress from 'react-native-progress';
import { Text, View, StyleSheet } from 'react-native';

class TrackFileRow extends React.Component {
    constructor(props) {
      super(props);
      
      this.state = {
        uploadingProgress: this.props.file.uploadingProgress
      }

      this.props.file.upload((uploadingProgress) => {
        this.setState({
          uploadingProgress: uploadingProgress
        })
      });
    }

    render() {
        return (
            <View style={styles.fileRow}>
                <Text style={styles.nameText}>{this.props.file.name}</Text>
                <Text style={styles.progressText}>{this.state.uploadingProgress === 200 ? "Upload Done!" : (this.state.uploadingProgress * 100).toFixed(2) + "%"}</Text>
                <View style={styles.progressContainer}>
                    <Progress.Bar style={styles.progress} unfilledColor={'#3d3d3d'} progress={this.state.uploadingProgress} width={345} height={3} />
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    fileRow: {
      height: 80,
      width: 375,
      backgroundColor: '#232323',
      justifyContent: 'center',
      borderRadius: 8,
      margin: 5,
    },
    progressContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: 15,
      paddingTop: 5,
    },
    progress: {
      borderColor: '#232323',
    },
    progressText: {
      fontSize: 12,
      fontWeight: 'regular',
      color: 'white',
      paddingLeft: 15,
      opacity: 0.75
    },
    nameText: {
      fontSize: 14,
      fontWeight: 'regular',
      color: 'white',
      paddingLeft: 15
    }
  });

export default TrackFileRow;